<template>
    <button>
        Clear All 
        <svg width="24.000000" height="24.000000" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <defs>
                <clipPath id="clip16_764">
                    <rect id="Outline=Cross" rx="0.000000" width="23.000000" height="23.000000" transform="translate(0.500000 0.500000)" fill="white" fill-opacity="0"/>
                </clipPath>
            </defs>
            <rect id="Outline=Cross" rx="0.000000" width="23.000000" height="23.000000" transform="translate(0.500000 0.500000)" fill="#FFFFFF" fill-opacity="0"/>
            <g clip-path="url(#clip16_764)">
                <path id="Union" d="M10.95 12.01L6.52 16.42L7.58 17.48L12.01 13.07L16.42 17.48L17.48 16.41L13.07 12.01L17.5 7.6L16.44 6.54L12.01 10.95L7.58 6.52L6.52 7.58L10.95 12.01Z" fill="#1D1D34" fill-opacity="1.000000" fill-rule="evenodd"/>
            </g>
        </svg>
    </button>
</template>

<script>
    export default {
        
    }
</script>

<style scoped>
button{
background: unset;
display: flex;
align-items: center;
gap: 8px;
/* Header/H4: 16px Medium */
color: rgb(29, 29, 52);
font-size: 16px;
font-weight: 500;
line-height: 140%;
letter-spacing: 0%;
text-align: left;
text-wrap: nowrap;
}
</style>